import Crossword from './crossword';

export default Crossword;
